module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarDropdown",
    staticClass: "sidebar-dropdown"
  }, _vm._l((_vm.data), function(entry, index) {
    return _c('div', {
      key: entry.key,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('erco-dropdown', {
      staticClass: "_input",
      attrs: {
        "items": _vm.mapItems(entry.enum),
        "currentItemIndex": _vm.getCurrentItemIndexFor(entry)
      },
      on: {
        "change": function($event) {
          _vm.handleSelect(index, $event)
        }
      }
    })], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f61057c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/Dropdown.vue
// module id = 604
// module chunks = 0